export default __webpack_public_path__ + "static/media/Genetics.de064001.png";